exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iconMaximize:hover {\n  color: #999; }\n\n.iconMaximize {\n  font-size: 24px;\n  cursor: pointer;\n  color: #FFF; }\n\n.blink_me {\n  -webkit-animation: blinker 1s linear infinite;\n          animation: blinker 1s linear infinite; }\n\n@-webkit-keyframes blinker {\n  50% {\n    opacity: 0; } }\n\n@keyframes blinker {\n  50% {\n    opacity: 0; } }\n\n.CambioAla {\n  font-weight: bold; }\n\n.NoUbicado {\n  font-size: 32px !important; }\n\n.w3-border-w, .w3-hover-border-red:hover {\n  border-color: black !important; }\n\n.w3-border-bottom {\n  border-bottom: 1px solid #ccc !important; }\n\n.w3-container, .w3-panel {\n  padding: 0.01em 16px; }\n\n.left {\n  text-align: left; }\n\n.icon-info-informe {\n  position: relative;\n  left: 0px;\n  top: 2px;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/historicoSeccionChart/historicoSeccionChart.component.scss
// module id = ../../../../../src/app/componentes/historicoSeccionChart/historicoSeccionChart.component.scss
// module chunks = main